import React, { Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { PAGES } from '@tesla/tw-react/dist/components/PageWrapper/Navigation/pages';
import { SuspenseLoader } from '~/common/components/SuspenseLoader';
import { NON_NAV_PAGES } from '~/common/utils/constants';

const Home = React.lazy(() => import(/* webpackChunkName: "Home" */ './Home'));
const OrderHistory = React.lazy(() =>
  import(/* webpackChunkName: "OrderHistory" */ './OrderHistory')
);

const LootBox = React.lazy(() => import(/* webpackChunkName: "LootBox" */ './LootBox'));

const ESign = React.lazy(() => import(/* webpackChunkName: "ESign" */ './ESign'));

const Confirmation = React.lazy(() =>
  import(/* webpackChunkName: "Confirmation" */ './Confirmation')
);

const DriverAccess = React.lazy(() =>
  import(/* webpackChunkName: "DriverAccess" */ './DriverAccess')
);

export default () => {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <Switch>
        <Route path={PAGES.REFER_AND_EARN.ROUTE} exact component={LootBox} />
        <Route path={PAGES.ORDER_HISTORY.ROUTE} exact component={OrderHistory} />
        <Route path={NON_NAV_PAGES.E_SIGN} exact component={ESign} />
        <Route path={NON_NAV_PAGES.CONFIRMATION} exact component={Confirmation} />
        <Route path={NON_NAV_PAGES.DRIVER_ACCESS} exact component={DriverAccess} />
        <Route path={PAGES.HOME.ROUTE} exact component={Home} />
        <Redirect to={{ pathname: PAGES.HOME.ROUTE }} />
      </Switch>
    </Suspense>
  );
};
